<div class="row">
  <div class="col-8">
    <h3 style="text-align: right;">New PurchaseCompany</h3>
  </div>
  <div class="col-3" (click)="closeComponent(false)" style="text-align: right;">
    <i class="material-icons" style="cursor: pointer; font-size: 28px;">
      cancel
    </i>
  </div>
</div>

<form [formGroup]="purchase_company_form">
  <div class="row">
    <div class="col">
      <div class="form-group">
        <label>Company Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <input type="text" class="form-control code_box" formControlName='company_name'>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-group">
        <label>GST Number</label>
        <input type="text" class="form-control code_box" formControlName='gst_number'>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-group">
        <label>Pan Number</label>
        <input type="text" class="form-control code_box" formControlName='pan_number'>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-group">
        <button mat-raised-button color="primary" (click)="registerPurchaseCompany()"
          [disabled]="!purchase_company_form.valid" style="text-transform: capitalize">Add</button>
      </div>
    </div>
  </div>
</form>
